import React from "react";
import Plot from "react-plotly.js";

const RadarChart = ({ termName, similarities, status }) => {
  // Mapear los datos de similitud según la estructura de sourceLEL
  // "Tipo" se agrega como eje propio siguiendo la última versión del notebook,
  // donde la similitud de tipo pasó a formar parte del radar.
  const labels = [
    "Tipo",
    "Nombre",
    "Nociones (TF-IDF)",
    "Impactos (TF-IDF)",
    "Nociones (N-gram)",
    "Impactos (N-gram)",
    "Nociones (Semántico)",
    "Impactos (Semántico)",
  ];

  // Convertir las similitudes a porcentajes (0-100)
  const pct = (v) => (typeof v === "number" && !Number.isNaN(v) ? v * 100 : 0);
  const values = [
    pct(similarities.type_similarity),
    pct(similarities.nombre_sim),
    pct(similarities.nociones_tfidf_sim),
    pct(similarities.impactos_tfidf_sim),
    pct(similarities.nociones_ngram_sim),
    pct(similarities.impactos_ngram_sim),
    pct(similarities.nociones_emb_sim),
    pct(similarities.impactos_emb_sim),
  ];

  // Cerrar el polígono agregando el primer valor al final
  const theta = [...labels, labels[0]];
  const r = [...values, values[0]];

  // Determinar el color según el estado
  const getColorByStatus = (status) => {
    switch (status?.toLowerCase()) {
      case 'similitud':
        return {
          fillcolor: "rgba(34, 197, 94, 0.3)", // Verde translúcido #22c55e
          lineColor: "rgb(34, 197, 94)",
          markerColor: "rgb(34, 197, 94)"
        };
      case 'diferencia':
        return {
          fillcolor: "rgba(251, 191, 36, 0.3)", // Amarillo translúcido #fbbf24
          lineColor: "rgb(251, 191, 36)",
          markerColor: "rgb(251, 191, 36)"
        };
      case 'omisión':
      case 'omision':
        return {
          fillcolor: "rgba(239, 68, 68, 0.3)", // Rojo translúcido #ef4444
          lineColor: "rgb(239, 68, 68)",
          markerColor: "rgb(239, 68, 68)"
        };
      default:
        return {
          fillcolor: "rgba(59, 130, 246, 0.3)", // Azul translúcido (por defecto)
          lineColor: "rgb(59, 130, 246)",
          markerColor: "rgb(59, 130, 246)"
        };
    }
  };

  const colors = getColorByStatus(status);

  const data = [
    {
      type: "scatterpolar",
      r: r,
      theta: theta,
      fill: "toself",
      fillcolor: colors.fillcolor,
      line: {
        color: colors.lineColor,
        width: 2,
      },
      marker: {
        color: colors.markerColor,
        size: 6,
      },
      name: termName,
    },
  ];

  const layout = {
    polar: {
      radialaxis: {
        visible: true,
        range: [0, 100],
        ticksuffix: "%",
        tickfont: {
          size: 10,
        },
      },
      angularaxis: {
        tickfont: {
          size: 11,
        },
      },
    },
    showlegend: false,
    title: {
      text: `Análisis de Similitud: ${termName}`,
      font: {
        size: 12,
        family: "Arial, sans-serif",
      },
    },
    margin: {
      l: 40,
      r: 40,
      t: 40,
      b: 20,
    },
    paper_bgcolor: "rgba(0,0,0,0)",
    plot_bgcolor: "rgba(0,0,0,0)",
  };

  const config = {
    displayModeBar: false,
    responsive: true,
    staticPlot: true, // Hace el gráfico completamente estático
    scrollZoom: false,
    doubleClick: false,
    showTips: false,
    displaylogo: false,
    modeBarButtonsToRemove: ['pan2d', 'select2d', 'lasso2d', 'zoom2d', 'zoomIn2d', 'zoomOut2d', 'autoScale2d', 'resetScale2d'],
  };

  return (
    <div className="w-full h-full">
      <Plot
        data={data}
        layout={layout}
        config={config}
        style={{ width: "100%", height: "100%" }}
        useResizeHandler={true}
      />
    </div>
  );
};

export default RadarChart;
